// MoreDropDown.jsx
import React, { useState, useRef, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Classes from '../Orders.module.css';

export default function MoreDropDown({ handleOpenAssignClientsPopup, handleOpenAddTaskPopup, handleOpenConfirmPopup, user }) {
  const [dropDown, setDropDown] = useState(false);
  const dropdownRef = useRef(null);
  const navigateTo = useNavigate();

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropDown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  function handleDelete() {
    console.log('Delete user => ', user._id);
    // optional: do a DELETE /user/:id
  }

  return (
    <div className={Classes.dropDown} ref={dropdownRef}>
      <div className="flexAlign10 pointer mr10" onClick={() => setDropDown(!dropDown)}>
        <button className={Classes.addBtn}>
          <h5>Actions</h5>
          <svg
            height='10px'
            fill={'white'}
            style={{ transform: dropDown ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s ease" }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
          </svg>
        </button>
      </div>

      <AnimatePresence>
        {dropDown && (
          <motion.div
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -5 }}
            transition={{ duration: 0.15 }}
            className={Classes.dropDownBody}
            style={{ top: '30px', right: '0' }}
          >
            <div className={Classes.dropDownBodyInner}>
              <div
                className={Classes.dropDownElem}
                style={{ padding: '5px 10px' }}
                onClick={() => {
                  navigateTo('/add-order')
                  setDropDown(false);
                }}
              >
                <h5>Edit</h5>
              </div>
              <div className={Classes.dropDownLine}></div>
              <div
                className={Classes.dropDownElem}
                style={{ padding: '5px 10px' }}
                onClick={() => {
                  handleOpenAssignClientsPopup();
                  setDropDown(false);
                }}
              >
                <h5>Assign clients</h5>
              </div>
              <div className={Classes.dropDownLine}></div>
              <div
                className={Classes.dropDownElem}
                style={{ padding: '5px 10px', color: 'red' }}
                onClick={() => {
                  handleOpenAddTaskPopup();
                  setDropDown(false);
                }}
              >
                <h5>Add task</h5>
              </div>
              <div className={Classes.dropDownLine}></div>
              <div
                className={Classes.dropDownElem}
                style={{ padding: '5px 10px', color: 'red' }}
                onClick={() => {
                  navigateTo('/add-invoice');
                  setDropDown(false);
                }}
              >
                <h5>Create an invoice</h5>
              </div>
              <div className={Classes.dropDownLine}></div>
              <div
                className={Classes.dropDownElem}
                style={{ padding: '5px 10px', color: 'red' }}
                onClick={() => {
                  handleOpenConfirmPopup();
                  setDropDown(false);
                }}
              >
                <h5>Delete order</h5>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <input type="hidden" aria-label="Without label" readOnly />
    </div>
  );
}
